<template>
  <div>
    <date-picker
      :query.sync="dateValue"
      v-bind="$attrs"
      v-on="$listeners"
      @change="handleSearch"
    />
  </div>
</template>

<script>
// 根据key 在对象中取值
const getDatePickerValue = (valueObj, keyList) => {
  let beginTime = '';
  let endTime = '';
  if (valueObj) {
    beginTime = valueObj[keyList[0]];
    endTime = valueObj[keyList[1]];
  }
  return {
    beginTime,
    endTime,
  };
};

export default {
  name: 'SearchDatePicker',
  props: {
    // 默认值
    value: {
      type: [Object, String],
      default: () => ({
        beginTime: '',
        endTime: '',
      }),
    },
    // 其他参数项
    queryItem: {
      type: Array,
      default: () => ['beginTime', 'endTime'],
    },
    // 组件参数项
    query: {
      type: Object,
    },
  },
  data() {
    const {
      beginTime,
      endTime,
    } = getDatePickerValue(this.value, this.queryItem);
    return {
      dateValue: {
        beginTime,
        endTime,
      },
    };
  },
  watch: {
    // 空值
    value: {
      handler() {
        const {
          beginTime,
          endTime,
        } = getDatePickerValue(this.value, this.queryItem);

        this.dateValue = {
          beginTime,
          endTime,
        };
      },
    },
  },
  methods: {
    handleSearch() {
      const {
        beginTime,
        endTime,
      } = getDatePickerValue(this.dateValue, ['beginTime', 'endTime']);
      // 其他参数返回值设定
      const [beginKey, endKey] = this.queryItem;

      this.$emit('setFormFields', {
        [beginKey]: beginTime,
        [endKey]: endTime,
      }, this.query);
    },
  },

};
</script>
